import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://www.ktiri.com';
const DEFAULT_IMAGE = `${SITE_URL}/images/kaspar-tiri-og.jpg`;
const SITE_NAME = 'Kaspar Tiri';

export default function SEO({ 
  title, 
  description, 
  image, 
  url,
  type = 'website',
  publishedTime,
  author = 'Kaspar Tiri'
}) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const fullUrl = url ? `${SITE_URL}${url}` : SITE_URL;
  const fullImage = image ? `${SITE_URL}${image}` : DEFAULT_IMAGE;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph - Facebook, LinkedIn, etc */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title || SITE_NAME} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:site_name" content={SITE_NAME} />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title || SITE_NAME} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />
      <meta name="twitter:creator" content="@sussisisse" />

      {/* Article specific (for blog posts) */}
      {type === 'article' && publishedTime && (
        <>
          <meta property="article:published_time" content={publishedTime} />
          <meta property="article:author" content={author} />
        </>
      )}

      {/* Structured Data for LLMs and Search Engines */}
      <script type="application/ld+json">
        {JSON.stringify(
          type === 'article' 
            ? {
                '@context': 'https://schema.org',
                '@type': 'BlogPosting',
                headline: title,
                description: description,
                image: fullImage,
                url: fullUrl,
                datePublished: publishedTime,
                author: {
                  '@type': 'Person',
                  name: author,
                  url: SITE_URL
                },
                publisher: {
                  '@type': 'Person',
                  name: SITE_NAME,
                  url: SITE_URL
                }
              }
            : {
                '@context': 'https://schema.org',
                '@type': 'Person',
                name: 'Kaspar Tiri',
                url: SITE_URL,
                jobTitle: 'Entrepreneur',
                description: 'Co-founder of Ready Player Me',
                sameAs: [
                  'https://www.linkedin.com/in/kaspartiri/',
                  'https://x.com/sussisisse'
                ]
              }
        )}
      </script>
    </Helmet>
  );
}

